/**
 * Intercept signup CTA clicks on public pages.
 *
 * This module reads the local 17906 variant or assigns it during page init,
 * then installs the click listener only for variant B. Control keeps native
 * link behavior.
 */
import { assignLocalSignupPageModal17906Variant } from '@/services/ab/experiments.public'
import {
  getClosestElement,
  getSignupUrl,
  openModalOrRedirect,
  redirectToSignup,
} from '@/pages-signup-modal/interception.helpers'

/**
 * Start signup CTA interception for public pages.
 */
export function initSignupCtaInterception17906(): () => void {
  if (assignLocalSignupPageModal17906Variant() !== 'B') {
    return (): void => {}
  }

  document.addEventListener('click', handleSignupCtaClick, true)

  return (): void => {
    document.removeEventListener('click', handleSignupCtaClick, true)
  }
}

/**
 * Intercept signup link clicks and route them through the experiment flow.
 */
function handleSignupCtaClick(event: MouseEvent): void {
  if (shouldSkipClick(event)) {
    return
  }

  const anchor = getClosestElement<HTMLAnchorElement>(event.target, 'a')
  const signupUrl = getSignupUrl(anchor)

  if (!signupUrl) {
    return
  }

  event.preventDefault()
  // The `void` marks the async call as intentionally fire-and-forget.
  void openModalOrRedirect(signupUrl, () => redirectToSignup(signupUrl))
}

/**
 * Skip clicks that should keep normal browser behavior.
 */
function shouldSkipClick(event: MouseEvent): boolean {
  return (
    event.defaultPrevented ||
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey
  )
}
